import Controller from "./fineReimbursement.controller";
import template from "./fineReimbursement.html";

const fineReimbursement = {
  template,
  controller: Controller,
};

export default fineReimbursement;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/fineReimbursement.component.js